module.exports = __webpack_public_path__ + "static/img/checking_logo.14097a01.png";